import classNames from 'classnames';
import { Menu } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { NavLinkData, ThemePopup } from '../../typings/common';
import { PopupDecorator } from '../PopupDecorator/PopupDecorator';
import { Shape2, Shape2Icon, Shape2Theme, Shape2Tone } from '../Shape2/Shape2';

import './HeaderInfoMenu.css';

export interface HeaderInfoMenuProps {
    cls?: string;
    links: Array<NavLinkData>;
}

export interface HeaderInfoMenuState {
    isPopupVisible: boolean;
}

export class HeaderInfoMenu extends React.PureComponent<
    HeaderInfoMenuProps,
    HeaderInfoMenuState
> {
    constructor(props: HeaderInfoMenuProps) {
        super(props);

        this.state = {
            isPopupVisible: false
        };
    }

    render() {
        const { cls, links } = this.props;
        const { isPopupVisible } = this.state;

        return (
            <div className={classNames(cls, Bem.cls('header-info-menu'))}>
                <Shape2
                    title={links.map(link => link.title).join(',')}
                    cls={Bem.cls('header-info-menu', 'switcher-icon')}
                    width={24}
                    height={24}
                    hoverable={true}
                    theme={
                        isPopupVisible ? Shape2Theme.default : Shape2Theme.light
                    }
                    icon={Shape2Icon.splitInfo}
                    tone={Shape2Tone.dark}
                    onClick={this.togglePopup}
                />

                {this.getPopup()}
            </div>
        );
    }

    private getPopup = () => {
        const { isPopupVisible } = this.state;
        const { links } = this.props;

        return (
            <PopupDecorator
                cls={Bem.cls('header-info-menu', 'popup')}
                theme={ThemePopup.CLEAR}
                onOutsideClick={this.closePopup}
                target={'anchor'}
                anchor={this}
                visible={isPopupVisible}
                directions={['bottom-center', 'bottom-right']}
                hasTail={true}
            >
                <Menu
                    theme="normal"
                    size="s"
                    type="navigation"
                    items={links.map(({ title, target, location }) => {
                        return {
                            text: title,
                            url: location,
                            target: target
                        };
                    })}
                />
            </PopupDecorator>
        );
    };

    private togglePopup = () => {
        this.setState({ isPopupVisible: !this.state.isPopupVisible });
    };

    private closePopup = () => {
        this.setState({ isPopupVisible: false });
    };
}
